// src/components/LabelWithAsterisk.js
import React from "react";

const LabelWithAsterisk = ({ label }) => {
  return (
    <span>
      {label} <span style={{ color: "red" }}>*</span>
    </span>
  );
};

export default LabelWithAsterisk;
